var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewers-bar"},_vm._l((_vm.allViewers),function(viewer){return _c('viewer',{key:viewer.uid,attrs:{"viewer":viewer}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }